import { render } from "./TableIncidences.vue?vue&type=template&id=6d492ac4&scoped=true"
import script from "./TableIncidences.vue?vue&type=script&lang=js"
export * from "./TableIncidences.vue?vue&type=script&lang=js"

import "./TableIncidences.vue?vue&type=style&index=0&id=6d492ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d492ac4"]])

export default __exports__